import { ApplicationTaskRoute } from 'types';

export enum SectionTitles {
  PERSONAL_STATEMENT = 'Personal statement',
  CONTACT_DETAILS = 'Contact details',
  DECLARATIONS = 'Declarations',
  DIVERSITY_AND_INCLUSION = 'Diversity and inclusion',
  EDUCATION = 'Education history',
  EMPLOYMENT = 'Employment history',
  ENGLISH_LANGUAGE = 'English language',
  FUNDING = 'Funding',
  IDENTITY = 'Identity',
  IMMIGRATION_HISTORY = 'Immigration history',
  REFERENCES = 'References',
  RESEARCH_PROPOSAL = 'Research proposal',
  REFERRAL = 'Referral',
  NATIONALITY = 'Nationality and residence',
  REPRESENTATION = 'Representation',
}

export const SectionTitleToRoute = {
  [SectionTitles.PERSONAL_STATEMENT]: ApplicationTaskRoute.PersonalStatement,
  [SectionTitles.CONTACT_DETAILS]: ApplicationTaskRoute.ContactDetails,
  [SectionTitles.DECLARATIONS]: ApplicationTaskRoute.Declarations,
  [SectionTitles.DIVERSITY_AND_INCLUSION]: ApplicationTaskRoute.DiversityInclusion,
  [SectionTitles.EDUCATION]: ApplicationTaskRoute.EducationHistory,
  [SectionTitles.EMPLOYMENT]: ApplicationTaskRoute.Employment,
  [SectionTitles.ENGLISH_LANGUAGE]: ApplicationTaskRoute.EnglishLanguage,
  [SectionTitles.FUNDING]: ApplicationTaskRoute.Funding,
  [SectionTitles.IDENTITY]: ApplicationTaskRoute.Identity,
  [SectionTitles.IMMIGRATION_HISTORY]: ApplicationTaskRoute.ImmigrationHistory,
  [SectionTitles.REFERENCES]: ApplicationTaskRoute.References,
  [SectionTitles.RESEARCH_PROPOSAL]: ApplicationTaskRoute.ResearchProposal,
  [SectionTitles.REFERRAL]: ApplicationTaskRoute.Referral,
  [SectionTitles.NATIONALITY]: ApplicationTaskRoute.NationalityResidence,
  [SectionTitles.REPRESENTATION]: ApplicationTaskRoute.Representation,
};
